import React from 'react'
import { problems } from '../lib/problems'
import { useNavigate } from 'react-router-dom'
import { Code, LogOut, User } from 'lucide-react'

const ProblemList: React.FC = () => {
  const navigate = useNavigate()

  const handleLogout = () => {
    // In a real app, this would clear auth state
    navigate('/')
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-primary-600 rounded-lg">
                <Code className="h-6 w-6 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-gray-900">DevWhisper</h1>
                <p className="text-sm text-gray-500">AI Voice Coding Mentor</p>
              </div>
            </div>
            <div className="flex items-center space-x-4">
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <User className="h-4 w-4" />
                <span>Demo User</span>
              </div>
              <button
                onClick={handleLogout}
                className="flex items-center space-x-2 px-3 py-2 text-gray-600 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200"
              >
                <LogOut className="h-4 w-4" />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Problems List */}
      <div className="container mx-auto px-4 py-10">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Choose a Problem to Solve</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select a coding challenge and start coding with AI mentorship. 
            Speak your thoughts while coding and get real-time feedback.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {problems.map((problem) => (
            <div key={problem.id} className="card flex flex-col h-full hover:shadow-lg transition-shadow">
              <div className="flex-1">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-xl font-semibold text-gray-900">{problem.title}</h3>
                  <span className={`inline-block px-2 py-1 rounded text-xs font-semibold ${
                    problem.difficulty === 'Easy' ? 'bg-green-100 text-green-700' : 
                    problem.difficulty === 'Medium' ? 'bg-yellow-100 text-yellow-700' : 
                    'bg-red-100 text-red-700'
                  }`}>
                    {problem.difficulty}
                  </span>
                </div>
                <p className="text-gray-700 mb-4 text-sm">{problem.description}</p>
                <div className="flex flex-wrap gap-2 mb-4">
                  {problem.tags?.map(tag => (
                    <span key={tag} className="bg-primary-100 text-primary-700 px-2 py-1 rounded text-xs font-medium">
                      {tag}
                    </span>
                  ))}
                </div>
                <div className="text-xs text-gray-500 mb-4">
                  <span className="font-medium">Languages:</span> {problem.supportedLanguages?.join(', ')}
                </div>
              </div>
              <button
                className="btn-primary mt-6"
                onClick={() => navigate(`/solve/${problem.id}`)}
              >
                Start Solving
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ProblemList 